import { Hexagon, MapPinned } from 'lucide-react';
import { COORDINATE_DECIMAL_PLACES } from '../../ReportComponent/constants/reportConstants';
import { formatAreaAdaptive } from '../../../utils/areaFormatting';

interface ReportMapProps {
  imageUrl?: string;
  drawingName?: string;
  drawingAreaKm2?: number;
  municipalityName?: string;
  isCitySelection?: boolean;
  markingCoordinates?: { lat: number; lng: number };
}

function formatCoordinates(coordinates: { lat: number; lng: number }): string {
  return `${coordinates.lat.toFixed(COORDINATE_DECIMAL_PLACES)}, ${coordinates.lng.toFixed(COORDINATE_DECIMAL_PLACES)}`;
}

export function ReportMap({
  imageUrl,
  drawingName,
  drawingAreaKm2,
  municipalityName,
  isCitySelection,
  markingCoordinates,
}: ReportMapProps) {
  if (!imageUrl) return null;

  const MarkingIcon = isCitySelection ? MapPinned : Hexagon;

  return (
    <section className="report-section report-map my-4">
      {drawingName && (
        <div className="py-2 mb-2">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2 text-[#0C2856]">
              <MarkingIcon size={20} strokeWidth={1.5} />
              <span className="text-[0.95rem] font-semibold">{drawingName}</span>
            </div>
            {drawingAreaKm2 !== undefined && (
              <span className="text-[0.95rem] font-semibold text-[#0C2856]">
                {formatAreaAdaptive(drawingAreaKm2)}
              </span>
            )}
          </div>
          {(municipalityName || markingCoordinates) && (
            <div className="flex items-center justify-between text-[0.85rem] text-[#0C2856]/80 mt-1">
              <span>{municipalityName}</span>
              {markingCoordinates && (
                <span>{formatCoordinates(markingCoordinates)}</span>
              )}
            </div>
          )}
        </div>
      )}

      <div className="w-full">
        <img
          src={imageUrl}
          alt="Mapa do projeto"
          className="w-full h-auto max-h-[380px] object-contain border border-[#ddd] rounded"
        />
      </div>
    </section>
  );
}
